'use client';
import { useState } from 'react';

export const usePaginationTable = (initialPage = 1, initialPageSize = 10) => {
  const [{ page, pageSize }, setPagination] = useState({
    page: initialPage,
    pageSize: initialPageSize,
  });

  const handlePageChange = (page: number) => {
    setPagination({ page, pageSize });
  };

  const handlePageSizeChange = (pageSize: number) => {
    setPagination({ page, pageSize });
  };

  return { page, pageSize, handlePageChange, handlePageSizeChange };
};
